import { request } from './request';

/**
 * PUT with an optional body — some endpoints carry everything in the path, e.g.
 * /apps/{cid}/permissions/{permission}, and have nothing left to send.
 */
export const putFetch = async <T>(
	token: string | null | undefined,
	url: string,
	body?: Record<string, unknown>
): Promise<T> => request<T>(url, { method: 'PUT', token, body });
